module.exports = __webpack_public_path__ + "media/images/icons/twotone/book-aa3bd9841164f00b9326426a8fa94e94.svg";